import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '@config/app.config';
import { ConstantsRepository } from '@core/repositories/constants.repository';
import { Constant } from '@shared/interfaces/constant';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiConstantsRepository implements ConstantsRepository {
  public url = this.appConfig.URL + '/amlcontrol/v1/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  edit(constant: Constant): Observable<any> {
    const data = {
      data: {}
    };
    return this.http.put(this.url, data);
  }
}
